/**
 * Sticker query keys, shared by the client hooks and the server prefetch.
 * Kept out of the "use client" hook module: a server component importing a
 * constant from there gets a client reference, not the value.
 */
export const stickerKeys = {
  mine: ["stickers", "mine"] as const,
  profile: (userId: string) => ["stickers", "profile", userId] as const,
};

/** What a profile's sticker row renders: both collections, by id. */
export interface ProfileStickersData {
  ownerIds: string[];
  /** The viewer's own ids; null when signed out. */
  viewerIds: string[] | null;
  isOwn: boolean;
}
